import { VectorDirection } from '@mews/enums';
import { createHandler } from '@mews/std';

export const flexDirectionHandler = createHandler({
    [VectorDirection.Column]: 'row',
    [VectorDirection.Row]: 'column',
});

export const indexHandler = createHandler<VectorDirection, Function>({
    [VectorDirection.Column]: (vectorIndex: number, cellIndex: number) => ({
        rowIndex: cellIndex,
        columnIndex: vectorIndex,
    }),
    [VectorDirection.Row]: (vectorIndex: number, cellIndex: number) => ({
        rowIndex: vectorIndex,
        columnIndex: cellIndex,
    }),
});
